import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconStopModule,
    TgIconBasicTickFramedModule,
    TgSelectModule,
    TgInputModule,
    TgRackModule,
    TgDateTimeFormatterModule,
    TgBoxes2Module
} from '@trademe/tangram';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { PropertyRentalAvailabilitySectionComponent } from './property-rental-availability-section.component';
import { TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySideCardModule } from '../../../components/property-side-card/property-side-card.module';
import { DraftValidationModule, WholeNumberDirectiveModule } from '@classifieds-sell/shared';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgIconBasicArrowRightModule,
        TgIconStopModule,
        TgIconBasicTickFramedModule,
        TgGridModule,
        TgSelectModule,
        TgInputModule,
        TgRackModule,
        LayoutModule,
        PropertySideCardModule,
        TrademeCoreUiModule,
        DraftValidationModule,
        TgDateTimeFormatterModule,
        WholeNumberDirectiveModule,
        TgBoxes2Module
    ],
    declarations: [PropertyRentalAvailabilitySectionComponent],
    providers: [TmDateComponent, DraftFacade],
    exports: [PropertyRentalAvailabilitySectionComponent]
})
export class PropertyRentalAvailabilitySectionModule {}
